import { DataActiveStatusEnum } from "../Category/types";
import { IImages } from "../product/types";

export interface IData {
  _id: string;
  title: string;
  code: string;
  price: string;
  taxRate: string;
  status: DataActiveStatusEnum;
  subCategoryTitle: string;
  type: PackageTypeEnum;
  subCategoryId: string;
  items: IItems[];
  allergicImages: IImages[];
  stickers: IImages[];
  images: IImages[];
  featuredImage: IImages[];
  itemsForm: IItems;
  shipmentCapacity:string
  createdAt: string;
  updatedAt: string;
}
export interface IItems {
  _id?: string;
  groupId: string;
  productId: string;
  remove?: boolean;
  groupTitle: string;
  productTitle: string;
  sortOrder?: number;
}
export enum PackageTypeEnum {
  Null = "Null",
  Customizable = "Customizable",
  Non_Customizable = "Non-Customizable",
}

export interface PackageState {
  formData: IData;
  list: IData[];
  allList: IData[];
  loading: boolean;
  buttonLoading: boolean;
  search: string;
  pageNo: number;
  pageSize: number;
  totalRow: number;
  orderBy: string;
  orderDir: string;
  toggleLoading: boolean;
  itemsLoading: boolean;
}

export type InitialState = PackageState;
